/*
***********************************************
this is added to the _MainLayout.cshtml file
***********************************************
*/

import Header4i from '../header/header.js';
import Footer4i from '../footer/footer.js';
import ScrollToTop4i from '../../common/scrolltotop25.js';
import ImageError4i from '../../common/imageerror25.js';
//TODO: Uncomment and test these imports
//import ContactPanel4i from '../contactpanel/contactpanel.js';
//import SiteImprove from '../../../thirdparty/siteimprove/siteimprove.js';
//import KameleoonTest from '../../../thirdparty/kameleoon/kameleoontest.js';
//import ServiceWorker from '../../../thirdparty/serviceworker/serviceworker.js';



async function init() {
    if (!('inert' in HTMLElement.prototype) || !('loading' in HTMLImageElement.prototype)) {
        const banner = await loadBannerUpgrade();
        if(banner) banner.init();
    }

    if(document.getElementById("needsRecaptcha")){
        const recaptcha = await loadRecaptcha();
        if(recaptcha) recaptcha.init();
    }

    ImageError4i.init();
    Header4i.init();
    ScrollToTop4i.init();
    Footer4i.init();

    //todo does this need to be in the head in layout file?
    //todo uncomment and test
    /*if(document.getElementById("needsNoibu")?.value === "true") {
        const noibu = await loadNoibu();
        if(noibu) noibu.init();
    }*/

    //todo test all of these
    //SiteImprove.init(); //todo uncomment and test
    //KameleoonTest.init(); //todo uncomment and test
    //ServiceWorker.init(); //todo uncomment and test
    //ContactPanel4i.init();  //todo uncomment and test
}


let recaptchaPromise = null;
let bannerPromise = null;
//let noibuPromise = null;

// Lazy load modules
async function loadBannerUpgrade(){
    if (!bannerPromise) {
        bannerPromise = import('../../common/upgradebrowser.js')
            .then(({ default: UpgradeBrowser4i }) => UpgradeBrowser4i)
            .catch((error) => {
                console.error("Failed to load upgrade banner:", error);
                bannerPromise = null; // Reset to allow retry
                return null;
            });
    }
    return bannerPromise;
}

async function loadRecaptcha() {
    if (!recaptchaPromise) {
        recaptchaPromise = import('../../thirdparty/recaptcha/recaptcha.js')
            .then(({ default: Recaptcha }) => Recaptcha)
            .catch((error) => {
                console.error("Failed to load recaptcha:", error);
                recaptchaPromise = null; // Reset to allow retry
                return null;
            });
    }
    return recaptchaPromise;
}

/*async function loadNoibu(){
    if (!noibuPromise) {
        noibuPromise = import('../../../thirdparty/noibu/noibu.js')
            .then(({ default: Noibu }) => Noibu)
            .catch((error) => {
                console.error("Failed to load noibu:", error);
                noibuPromise = null; // Reset to allow retry
                return null;
            });
    }
    return noibuPromise;
}*/

await init();